import React from 'react';
import { Navigation } from 'navigation';
import 'assets/styles/common.scss';
// import { useAuth } from './hooks';

export const App = () => {
  // useAuth()
  return <Navigation/>
};